module.exports = __webpack_public_path__ + "static/assets/5032ec340ed8a75a3d8438714aa91334.svg";